export const prepareAlgoliaPayload = ({ currentUser, listing }) => {
  const listingAttr = listing?.attributes || {};
  const publicData = listingAttr?.publicData || {};
  const geo = listingAttr?.geolocation || {};

  const userAttr = currentUser?.attributes || {};
  const profile = userAttr?.profile || {};
  const userPublicData = profile?.publicData || {};
  const userProtectedData = profile?.protectedData || {};

  const boothTypes = Array.isArray(publicData?.boothTypes) ? publicData.boothTypes : [];

  const boothTypeSubcategories = boothTypes
    .flatMap(bt => publicData?.[bt]?.subCategories)
    .filter(Boolean);

  return {
    objectID: listing?.id?.uuid,

    title: listingAttr?.title,
    state: listingAttr?.state,

    _geoloc: {
      lat: geo?.lat || 0,
      lng: geo?.lng || 0
    },

    address1: {
      selectedPlace: {
        address: publicData?.address1?.selectedPlace?.address
      }
    },

    biddingDeadline: publicData?.biddingDeadline,
    eventStartDateUnix: publicData?.eventStartDateUnix,
    eventEndDateUnix: publicData?.eventEndDateUnix,
    companyName: publicData?.companyName,
    eventBid: publicData?.eventBid,
    eventDates: publicData?.eventDates,
    eventDetails: publicData?.eventDetails,
    eventTimeWindows: publicData?.eventTimeWindows,
    eventTitle: publicData?.eventTitle,
    eventType: publicData?.eventType,
    listingType: publicData?.listingType,
    postcode: publicData?.postcode,
    region: publicData?.region,
    rfpTimeframe: publicData?.rfpTimeframe,
    transactionProcessAlias: publicData?.transactionProcessAlias,
    typeOfListing: publicData?.typeOfListing,
    unitType: publicData?.unitType,
    locationName: publicData?.locationName,
    boothTypes,
    boothTypeSubcategories,

    venueAddress: {
      selectedPlace: {
        address: publicData?.venueAddress?.selectedPlace?.address,
        origin: publicData?.venueAddress?.selectedPlace?.origin
      }
    },

    user: {
      id: currentUser?.id?.uuid,
      email: userAttr?.email,
      firstName: profile?.firstName,
      displayName: profile?.displayName,
      businessListingId: userProtectedData?.businessListingId,
      businessListingPublished: userProtectedData?.businessListingPublished,
      companyCoverPhoto: userPublicData?.companyCoverPhoto,
      companyName: userPublicData?.companyName,
      companyPhone: userPublicData?.companyPhone,
      companyWebsite: userPublicData?.companyWebsite,
      website: userPublicData?.website,
      yearFounded: userPublicData?.yearFounded,
      zipCodeRadius: userPublicData?.zipCodeRadius
    },

    ...(publicData?.dj_services && { dj_services: publicData?.dj_services }),
    ...(publicData?.ipadCamera && { ipadCamera: publicData?.ipadCamera })
  };
}
